import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();


// Cookie utility functions
const setCookie = (name, value, hours = 24) => {
  const date = new Date();
  date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/;SameSite=Strict;Secure`;
};

const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

// Storage object to mimic the original storage interface
export const storage = {
  set: (key, value) => {
    setCookie(key, value, 24);
  },
  get: (key) => {
    return getCookie(key);
  },
  delete: (key) => {
    deleteCookie(key);
  }
};

export const authUser = async (username, password) => {
  try {
    const response = await fetch(`${config.API_BASE_URL}/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent': 'agentApp/1.0',
      },
      body: JSON.stringify({
        username: username,
        password: password,
      }),
    });

    if (response.ok) {
      // Extract the JSON body of the response
      const responseData = await response.json();
      
      // Store auth token in cookie (expires in 24 hours)
      setCookie('authToken', responseData.data.token, 24);
      
      
      return responseData.status; // Return the response data if needed
    } else {
      throw new Error(`Error authenticating user`);
    }
  } catch (error) {
  
    throw error;
  }
};

export const getUserInfo = () => {
  const firstName = storage.get('userFirstName');
  const lastName = storage.get('userLastName');
  
  return {
    firstName: firstName || '',
    lastName: lastName || '',
    fullName: `${firstName || ''} ${lastName || ''}`.trim()
  };
};

// Helper function to get auth token for API calls
export const getAuthToken = () => {
  return getCookie('authToken');
};

// Helper function to check if user is authenticated
export const isAuthenticated = () => {
  return !!getAuthToken();
};

// Helper function to logout (clear all auth data)
export const logout = () => {
  deleteCookie('authToken');
};

// Example of how to use the auth token in other API calls
export const authenticatedFetch = async (url, options = {}) => {
  const token = getAuthToken();
  
  if (!token) {
    throw new Error('No authentication token found');
  }
  
  const authHeaders = {
    ...options.headers,
    'Authorization': `Bearer ${token}`,
  };
  
  return fetch(url, {
    ...options,
    headers: authHeaders,
  });
};